import { ActionTypes } from "../constants/ActionTypes";
export const setAllForms = (payload) => (dispatch) => {
    try {

        dispatch({ type: ActionTypes.FETCH_ALL_FORMS_SUCCESS, payload: payload })
    }
    catch (err) {
        dispatch({ type: ActionTypes.FETCH_ALL_FORMS_FAIL, payload: err })
    }
}

export const setCurrentForm = (payload) => (dispatch) => {
    try {

        dispatch({ type: ActionTypes.SET_CURRENT_FORM, payload: payload })
    }
    catch (err) {
        console.log(err);
    }
}

export const updateForm = () => (dispatch) => {
    try {
        dispatch({ type: ActionTypes.UPDATE_FORM })
    }
    catch (err) {
        console.log(err);
    }
}

export const addQuestion = (payload) => (dispatch) => {
    try {

        dispatch({ type: ActionTypes.ADD_QUESTION, payload: payload })
    }
    catch (err) {
        console.log(err);
    }
}
export const removeQuestion = (payload) => (dispatch) => {

    try {
        dispatch({ type: ActionTypes.REMOVE_QUESTION, payload: payload })

    } catch (err) {
        console.log(err);
    }
}
export const updateQuestions = (payload) => (dispatch) => {
    try {
        dispatch({ type: ActionTypes.UPDATE_QUESTIONS, payload: payload })

    } catch (err) {
        console.log(err);
    }
}
export const reorderQuestion = (payload) => (dispatch) => {
    try {
        dispatch({ type: ActionTypes.REORDER_QUESTIONS, payload: payload })

    } catch (err) {
        console.log(err);
    }
}
export const updateTheme = (payload) => (dispatch) => {
    try {
        dispatch({ type: ActionTypes.UPDATE_THEME, payload })
    }
    catch (err) {
        console.log(err);
    }
}
export const toggleFormVisibility = (payload) => (dispatch) => {
    try {
        dispatch({ type: ActionTypes.TOGGLE_FORM_VISIBILITY, payload: payload })
    }
    catch (err) {
        console.log(err);
    }
}

export const updateOptions = (payload) => (dispatch) => {
    try {
        dispatch({ type: ActionTypes.UPDATE_OPTIONS, payload: payload })

    } catch (err) {
        console.log(err);
    }
}

export const updateFormDetails = (payload) => (dispatch) => {
    try {

        dispatch({ type: ActionTypes.UPDATE_FORM_DETAILS, payload: payload })
    }
    catch (err) {
        console.log(err);
    }
}


export const viewSingleForm = (payload) => (dispatch) => {
    try {
        dispatch({ type: ActionTypes.VIEW_SINGLE_FORM, payload: payload })
    }
    catch (err) {
        console.log(err);
    }
}
